// extracted by mini-css-extract-plugin
export default {"loader-overlay":"Loader_loader-overlay__FvLqs","spinner":"Loader_spinner__kAo9x","spin":"Loader_spin__uXQRz"};